// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"202dbfba","476":"a4627e1c","508":"f8fe7517","787":"66dc2a5a","879":"f8fe7517"}[chunkId] + ".chunk.js";
};